<template>
  <div>Desktop Version Event Detail</div>
</template>

<script>
export default {

}
</script>

